export default __webpack_public_path__ + "static/media/csvDownload.6593542f.png";